// lib/nav.js — maps the app's internal route keys (unchanged from the
// original site's onNav('capabilities/epcm') style calls) to real Next.js
// paths, and exposes a client-side nav() function backed by next/navigation
// so every ported component's existing onNav prop keeps working unmodified.

'use client';

import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

const ROUTE_TO_URL = {
  home: '',
  capabilities: 'services',
  'capabilities/epcm': 'services/epcm',
  'capabilities/rd': 'services/rd',
};

export function routeToUrl(route) {
  if (!route || route === 'home') return '/';
  const mapped = ROUTE_TO_URL[route];
  const key = mapped !== undefined ? mapped : route;
  return key ? `/${key}` : '/';
}

export function useOnNav() {
  const router = useRouter();
  return useCallback(
    (target) => {
      router.push(routeToUrl(target));
    },
    [router]
  );
}
